<template>
  <div class="">
    <el-card>
      <el-row style="margin-bottom: 10px;">
        <el-col :span="12">
          <el-tag size="medium" effect="dark" style="font-size: 15px;">{{ roomDescribe }}</el-tag>
        </el-col>
        <el-col :span="12" align="right">
          <el-button style="line-height: 3px;" type="primary" @click="jump">{{ $t('lang.btn_backpage') }}</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <!-- 左侧楼号/单元/房间树 -->
        <!-- <el-col :span="5">
          <el-tree
            class="room-tree"
            :data="treeData"
            node-key="id"
            :props="treeProps"
            lazy
            :load="loadTreeNode"
            show-checkbox
            @node-click="handleTreeNodeClick"
          />
        </el-col> -->
        <!-- 右侧收费列表 -->
        <el-col :span="24">
          <!-- <el-button type="primary" slot="header" @click="add">{{detail.btn_createFeeConfig}}</el-button>  -->
          <el-table
            :data="tableData"
            class="wid100"
            :row-class-name="tableRowClassName"
            @selection-change="handleSelectionChange"
            @filter-change="handleFilterChange"
            :height="tableData.length > 0 ? require('@/config/enum').tableheight655 : require('@/config/enum').tableheight109"
          >
            <el-table-column type="selection" width="55" v-if="this.postAuditListcheckbox"></el-table-column>
            <el-table-column
              type="index"
              :index="indexMethod"
              align="center"
              :label="$t('lang.lab_index')"
              width="100px"
            ></el-table-column>
            <el-table-column prop="configId" :label="$t('lang.lab_configId')" v-if="false"></el-table-column>
            <el-table-column prop="feeName" :label="$t('lang.lab_feeName')"></el-table-column>
            <el-table-column prop="feeFlagName" :label="$t('lang.lab_feeFlagName')" width="150"></el-table-column>
            <el-table-column
              prop="feeTypeCdName"
              v-if="feeRoomOrCar == 'homeFee'"
              label-class-name="ftc"
              column-key="feeTypeCdName"
              :label="$t('lang.lab_feeTypeCdName')"
              width="150"
              :filters="[
                { text: '物业费', value: '888800010001' },
                { text: '服务费', value: '888800010013' },
                { text: '押金', value: '888800010006' },
                { text: '其他', value: '888800010014' },
                { text: '储值卡', value: '888800010011' },
              ]"
            ></el-table-column>
            <el-table-column
              prop="feeTypeCdName"
              v-else
              column-key="feeTypeCdName"
              :label="$t('lang.lab_feeTypeCdName')"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="placeName"
              v-if="feeRoomOrCar == 'carFee'"
              label-class-name="ftc"
              width="150"
            >
              <template slot="header">
                <span>{{ $t('lang.lab_parkingNumber') }}</span>
                <span
                  class="place-name-filter-trigger"
                  :class="{ 'is-active': placeName }"
                  @click.stop="togglePlaceNameFilter"
                >
                  <i class="el-icon-arrow-down"></i>
                </span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="num" v-if="feeRoomOrCar=='homeFee'" label="仪表编号" width="150"></el-table-column> -->
            <el-table-column prop="weName" v-if="feeRoomOrCar == 'homeFee'" label="仪表名称" width="150">
              <template slot-scope="scope">
                <span class="haveParentIdstyle" @click="consumeShow(scope.row)">{{ scope.row.weName }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('lang.lab_amountOwed')" width="100">
              <template slot-scope="scope">
                <el-input
                  v-if="scope.row.feeFlag == '2006012'"
                  v-model="scope.row.revAmount"
                  class="revInput"
                  :disabled="revFlag"
                  @change="modifyPayFee(scope.row)"
                ></el-input>
                <div v-else>{{ scope.row.revAmount }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="startTime" :label="$t('lang.lab_buildTime')">
              <template slot-scope="scope">
                {{ scope.row.startTime | timeYMD }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('lang.lab_startTime')">
              <template slot-scope="scope">
                <div style="text-align: left;" v-if="getEndTime(scope.row) == '―'">{{ getEndTime(scope.row) }}</div>
                <div v-else>{{ getEndTime(scope.row) | timeYMD }}</div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('lang.lab_finishTime')">
              <template slot-scope="scope">
                <div style="text-align: left;" v-if="getDeadlineTime(scope.row) == '―'">
                  {{ getDeadlineTime(scope.row) }}
                </div>
                <div v-else>{{ getDeadlineTime(scope.row) | timeYMD }}</div>
              </template>
            </el-table-column>

            <el-table-column :label="$t('lang.lab_descriptionFee')" width="150">
              <template slot-scope="scope">
                <el-tag size="medium" effect="dark" class="tagStyle">面积：{{ getDisplayArea(scope.row) }}</el-tag>
                <!-- <div>面积：{{builtUpArea}}</div> -->
                <el-tag size="medium" effect="dark" class="tagStyle">单价：{{ scope.row.squarePrice }}</el-tag>
                <!-- <div>单价：{{scope.row.squarePrice}}</div> -->
                <el-tag
                  effect="dark"
                  v-if="scope.row.feeFlag == '1003006' && feeRoomOrCar == 'homeFee'"
                  class="tagStyle"
                  >附加费：{{ scope.row.additionalAmount }}</el-tag
                >
                <el-tag effect="dark" class="tagStyle" v-else>固定费：{{ scope.row.additionalAmount }}</el-tag>
                <!-- <div v-if="scope.row.feeFlag == '1003006'">附加费：{{scope.row.additionalAmount}}</div>
              <div v-else>固定费：{{scope.row.additionalAmount}}</div> -->
              </template>
            </el-table-column>
            <el-table-column
              prop="stateName"
              label-class-name="ftc"
              column-key="stateName"
              :label="$t('lang.lab_stateName')"
              :filters="[
                { text: '收费中状态', value: '2008001' },
                { text: '当期收费结束', value: '2020001' },
                { text: '收费结束', value: '2009001' },
              ]"
            ></el-table-column>

            <el-table-column prop="operation" :label="$t('lang.lab_operation')" width="200px">
              <template slot-scope="scope">
                <el-button v-if="scope.row.state == '2008001'" @click="payMoney(scope.row)">
                  {{ $t('lang.lab_payMoneys') }}
                </el-button>
                <el-button @click="payFeeHistory(scope.row.feeId)">
                  {{ $t('lang.lab_payFeeHistory') }}
                </el-button>
                <el-button @click="payDeleteMoney(scope.row)">{{ $t('lang.btn_delete') }}</el-button>
                <el-button
                  v-if="scope.row.feeFlag == '2006012' && scope.row.state == '2008001'"
                  @click="revFlag = !revFlag"
                  >{{ $t('lang.btn_modify') }}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNo"
            :page-sizes="[5]"
            :page-size="pageSize"
            layout="sizes, prev, pager, next, jumper"
            :page-count="pageCount"
          />
        </el-col>
      </el-row>
    </el-card>
    <!-- 车位号筛选浮层：放在表格外，避免固定表头复制导致无法输入 -->
    <div
      v-if="feeRoomOrCar == 'carFee' && placeNameFilterVisible"
      ref="placeNameFilterPanel"
      class="place-name-filter-floating"
      :style="placeNameFilterPosition"
    >
      <el-input
        ref="placeNameFilterInput"
        v-model="placeNameFilterInput"
        placeholder="请输入车位号"
        clearable
        size="small"
        @keyup.enter.native="confirmPlaceNameFilter"
      />
      <div class="place-name-filter-actions">
        <el-button size="mini" @click="resetPlaceNameFilter">重置</el-button>
        <el-button type="primary" size="mini" @click="confirmPlaceNameFilter">筛选</el-button>
      </div>
    </div>
     <el-dialog :title="title" :visible.sync="isPopupDetail" :close-on-click-modal="false" center top="5px !important"
      width="65%!important" @closed="rechargeHandleDialogClosed">
      <div>
        <el-table :data="diaRecharge" ref="diaReceiveRef"
          :height="diaRecharge.length > 0 ? require('@/config/enum').tableheight400 : require('@/config/enum').tableheight119"
          :row-class-name="tableRowClassName"
          :cell-style="{padding: '5px 0 !important'}">
          <el-table-column type="index" :index="rechargeIndexMethod" align="center" :label="$t('lang.lab_index')" width="120px"> </el-table-column>
          <el-table-column width="" prop="Degree" label="仪表度数"></el-table-column>
          <el-table-column width="" prop="CreateTime" label="创建时间">
            <template slot-scope="scope">
              {{scope.row.CreateTime|time}}
            </template>
          </el-table-column>
          <el-table-column prop="operation" :label="$t('lang.lab_operation')" width="180px">
            <template slot-scope="scope">
              <el-button v-if="isFeeManager===1" @click="delRecharge(scope.row)">{{$t('lang.btn_delete')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="handleRechargeSizeChange"
        @current-change="handleRechargeCurrentChange"
        :current-page="rechargePageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="rechargePageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="rechargePageCount"
        class="fee-pagination"
      />
    </el-dialog>
  </div>
</template>

<script>
// import { config } from '@fullcalendar/core'
/**
 *@ClassName:feeroomlist
 *@Description:房屋收费
 *@author:xubz
 *@Copyright:格众科技
 *@date:2020-11-26
 */
export default {
  data() {
    return {
        diaFreeParam:{
          startTime: '',
          endTime: ''
        },
        diaRecharge:[],
      isPopupDetail:false,
      currentWeId: '',
      rechargePageNo: 1,
      rechargePageSize: 10,
      rechargePageCount: 0,
      isFeeManager:0,
      zero: 0, // 值为0的变量
      multipleSelection: [], // 多选框
      pageCount: 0, // 总页数
      title: '仪表日志列表', // 弹框显示的标题
      pageNo: 1, // 第几页
      pageSize: 5, // 每页显示数
      types: [], // 小区下拉
      houseId: 0, // 楼号ID
      unitId: 0, // 单元号ID
      houseList: [], // 楼号列表
      unitList: [], // 单元号列表
      tableData: [], // 列表数组
      searchMacName: '', // 搜索的关键字
      disabled: true,
      editId: '', // 编辑按钮保存的id
      isPopupPage: false, // 弹框的显示控制
      gardenDialist: [], // 弹框的小区列表
      houseDialist: [], // 弹框的楼号列表
      unitDialist: [], // 弹框的单元列表
      roomDialist: [], // 弹出的房间列表
      detail: this.$i18n.t('lang.feePay'), // 列表数据 xu
      diaForm: {
        gardenId: '',
        house: 0,
        unit: 0,
        room: 0,
        type: 1,
        locationTypeCd: '',
        feeTypeCd: '',
        configId: '',
        startTime: '',
        // -------------------------
        feeName: '',
        feeFlag: '',
        paymentCd: '',
        paymentCycle: '',
        billTypeName: '',

        endTime: '',
        computingFormula: '',
        squarePrice: '',
        additionalAmount: '',
      },
      postAuditListcheckbox: require('@/config/enum').postAuditListcheckbox, // 是否隐藏复选框
      isDisabled: true, // 保存的可点击
      // gardenId: 0, // 小区绑定的id
      // ---------------------
      isDefault: 0, //
      // feeTypeList: [],
      // feeConfigList: [],
      // 本页面我写的其他很多没有用到的参数。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。
      gardenId: '',
      room: 0,
      builtUpArea: '',
      feeArea: '',
      gardenName: '',
      houseName: '',
      unitName: '',
      roomName: '',
      ownerName: '',
      roomDescribe: '',
      row: {},
      diaFree: {
       feeId: '', 
       builtUpArea: '',
      },
      price: '',
      feeTypeCdName: '',
      stateName: '',
      placeName: '',
      placeNameFilterInput: '',
      placeNameFilterVisible: false,
      placeNameFilterPosition: {},
      feeRoomOrCar: '',
      revFlag: true,
      // 楼号/单元/房间树
      treeData: [],
      treeProps: {
        label: 'name',
        children: 'children',
        isLeaf: 'isLeaf',
      },
    }
  },
  created() {
    this.isFeeManager = this.$store.getters.isFeeManager
    this.diaForm.gardenId = this.$store.getters.gardenId
    // this.getGarden()
    if (this.$route.query.row['gardenId'] == undefined) {
      this.row = JSON.parse(window.localStorage.getItem('roomLists'))
      this.feeRoomOrCar = this.row.feeRoomOrCar
    } else {
      window.localStorage.removeItem('roomLists')
      window.localStorage.setItem('roomLists', JSON.stringify(this.$route.query.row))
      this.row = this.$route.query.row
      this.feeRoomOrCar = this.row.feeRoomOrCar
    }
    this.getTablelist(this.row)
    // this.getFeeDictList()
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handlePlaceNameFilterOutsideClick)
  },
    
  watch: {
    diaForm: {
      handler(newVal, oldVal) {
        // form数据变化时 会调用此方法
        let tempRule = JSON.stringify(newVal)
        if (tempRule == this.saveData) {
          // 没变
          this.isDisabled = true
        } else {
          // 变了
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    getDisplayArea(row) {
      if (row.feeTypeCd === '888800010009') {
        return row.placeArea || '―'
      }
      return this.builtUpArea
    },
    // 楼号/单元/房间树懒加载
    loadTreeNode(node, resolve) {
      debugger
      // 根节点加载楼号
      let type = 1
      let parentId = this.gardenId
      if (node.level === 0) {
        type = 1
        parentId = this.gardenId
      } else if (node.level === 1) {
        // 楼号下加载单元
        type = 2
        parentId = node.data.id
      } else if (node.level === 2) {
        // 单元下加载房间
        type = 3
        parentId = node.data.id
      } else {
        resolve([])
        return
      }
      this.$get(`/gardenGrids/?type=${type}&parentId=${parentId}&pageNo=1&pageSize=9999`).then(
        res => {
          if (res && res.errCode === 0) {
            const list = res.list || []
            // 房间节点标记为叶子节点
            if (type === 3) {
              list.forEach(item => {
                item.isLeaf = true
              })
            }
            resolve(list)
          } else {
            resolve([])
          }
        },
        () => {
          resolve([])
        }
      )
    },
    // 点击树节点，根据楼号/单元/房间切换右侧列表
    handleTreeNodeClick(data, node) {
      // 只在点击房间节点时刷新收费数据
      if (node.level !== 3) {
        return
      }
      // 复制一份当前行参数，只替换房间相关信息
      const newRow = Object.assign({}, this.row)
      newRow.roomId = data.id
      newRow.roomName = data.name
      // 从树节点层级中取楼号、单元名称
      if (node.parent && node.parent.data) {
        newRow.unitName = node.parent.data.name
      }
      if (node.parent && node.parent.parent && node.parent.parent.data) {
        newRow.houseName = node.parent.parent.data.name
      }
      this.row = newRow
      this.getTablelist(newRow)
    },
    rechargeHandleDialogClosed(){
        this.isPopupPage = false
        this.currentWeId = ''
        this.rechargePageNo = 1
        this.rechargePageSize = 10
        this.rechargePageCount = 0
        this.diaRecharge = []
    },
    consumeShow(row) {
        this.rechargePageNo = 1
        this.rechargePageSize = 10
        this.currentWeId = row.weId
        this.isPopupDetail = true
        this.feeRechargeList(row.weId)
      },
    feeRechargeList(weId) {
      const waterElectricityId = weId || this.currentWeId
      if (!waterElectricityId) {
        return
      }
      this.currentWeId = waterElectricityId
      let loading = this.$loading()
        let params = {
          pageNo: this.rechargePageNo,
          pageSize: this.rechargePageSize,
          waterElectricityId: waterElectricityId,
          startTs: this.diaFreeParam.startTime,
          endTs: this.diaFreeParam.endTime,
      }
      this.$get(`/getWaterElectricityDegreeList`, params).then(
        (res) => {
          loading.close()
          if (res && res.errCode === 0) {
            this.diaRecharge = res.list || []
            this.rechargePageCount = res.pageCount || 0
          }
        },
        (error) => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    delRecharge(row) {
         this.$confirm(this.$i18n.t('lang.lab_isdelete'),
            this.$i18n.t('lang.lab_prompt'), {
            confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
            type: 'warning'
          })
          .then(() => {
            let loading = this.$loading()
            this.$patch(`/delWaterElectricityDegree/${row.Id}`,{}).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_del_success'))
                    this.feeRechargeList(row.WaterElectricityId || this.currentWeId)
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
              // })
              .catch(() => {
                loading.close()
                this.$message({
                  type: 'info',
                  message: this.$i18n.t('lang.lab_del_can')
                })
              })
        })
      },
    rowStyle(){
                return "text-align:center"
            },
    modifyPayFee(row){
      let loading = this.$loading()
      let params = {
        revAmountOnce: row.revAmount,
      }
      this.$post(`/modifyPayFee/${row.feeId}`, params).then(
        (res) => {
          loading.close()
          if (res && res.errCode === 0) {
            this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_modify_success')
                  })
                    this.getTablelist(this.row)
                    this.revFlag =true
            }
        },
        (error) => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    handleFilterChange(value) {
      if (value.hasOwnProperty('stateName')) {
          this.stateName = value.stateName.join(',')
      }
      if (value.hasOwnProperty('feeTypeCdName')) {
          this.feeTypeCdName = value.feeTypeCdName.join(',')
      }
      this.pageNo = 1
      this.getTablelist(this.row)
    },
    togglePlaceNameFilter(event) {
      if (this.placeNameFilterVisible) {
        this.closePlaceNameFilter()
        return
      }
      const rect = event.currentTarget.getBoundingClientRect()
      this.placeNameFilterPosition = {
        position: 'fixed',
        top: (rect.bottom + 4) + 'px',
        left: rect.left + 'px',
        zIndex: 3001
      }
      this.placeNameFilterInput = this.placeName
      this.placeNameFilterVisible = true
      this.$nextTick(() => {
        const input = this.$refs.placeNameFilterInput
        if (input && typeof input.focus === 'function') {
          input.focus()
        }
        setTimeout(() => {
          document.addEventListener('click', this.handlePlaceNameFilterOutsideClick)
        }, 0)
      })
    },
    handlePlaceNameFilterOutsideClick(event) {
      const panel = this.$refs.placeNameFilterPanel
      if (panel && panel.contains(event.target)) {
        return
      }
      if (event.target.closest && event.target.closest('.place-name-filter-trigger')) {
        return
      }
      this.closePlaceNameFilter()
    },
    closePlaceNameFilter() {
      this.placeNameFilterVisible = false
      document.removeEventListener('click', this.handlePlaceNameFilterOutsideClick)
    },
    confirmPlaceNameFilter() {
      this.placeName = (this.placeNameFilterInput || '').trim()
      this.closePlaceNameFilter()
      this.pageNo = 1
      this.getTablelist(this.row)
    },
    resetPlaceNameFilter() {
      this.placeNameFilterInput = ''
      this.placeName = ''
      this.closePlaceNameFilter()
      this.pageNo = 1
      this.getTablelist(this.row)
    },
    payDeleteMoney(row) {
      let loading = this.$loading()
        this.$confirm(this.$i18n.t('lang.lab_isdelete'), this.$i18n.t('lang.lab_prompt'), {
            confirmButtonText: this.$i18n.t('lang.btn_confirm'),
            cancelButtonText: this.$i18n.t('lang.btn_cancel'),
            type: 'warning'
          })
          .then(() => {
            this.$delete(`/delFeePayById/${row.feeId}`).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                    this.getTablelist(this.row)
                    this.getFeeDictList()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
    },
     jump() {
      this.$router.push({
        name: 'feePayList'
      })
    },
    payFeeHistory(feeId) {
       let params = {
        feeId: feeId,
        gardenId: this.gardenId,
        pageNo: 1,
        pageSize: 5,
        builtUpAre: this.builtUpArea,
        roomDescribe: this.roomDescribe,
        ownerName: this.ownerName,
        ownerId:this.row.ownerId,
      }
      // 方案 A：补齐 localStorage，确保 feeProperty.vue 的 created() 能稳定拿到参数
      try {
        window.localStorage.setItem('paramsls', JSON.stringify(params))
        window.localStorage.setItem('rowls', JSON.stringify(this.row || {}))
      } catch (e) {
        // 防止 localStorage 不可用导致页面直接崩溃
        console.warn('set paramsls/rowls failed', e)
      }
      this.$router.push({ name: 'feeProperty', query: { params: params, row: this.row, feeRoomOrCar: this.feeRoomOrCar } })
    },
     // 收费  许
    payMoney(row) {
      debugger
      let params = {
        feeId: row.feeId,
        pageNo: 1,
        pageSize: 5,
        builtUpAre: this.builtUpArea,
        feeArea: this.feeArea,
        roomDescribe: this.roomDescribe,
        price: row.squarePrice
      }
      this.$router.push({ name: 'feePay', query: { params: params, row: this.row, feeRoomOrCar: this.feeRoomOrCar } })
    },
    // 许
     getDeadlineTime(fee) {
      if (fee.revAmount == 0 && fee.endTime >= fee.receiveTime) {
        return '―'
      }

      if (fee.state == '2009001' || fee.state == '2020001') {
        return '―'
      }

      return fee.receiveTime
    },
     // 许
     getEndTime(fee) {
      if (fee.state == '2009001') {
        return '―'
      }
      return fee.endTime
    },
    // 许
    getTablelist(row) {
      debugger
      this.gardenId = row.gardenId
      this.room = row.roomId
      this.builtUpArea = row.buildArea
      this.feeArea = row.feeArea
      this.gardenName = row.gardenName
      this.houseName = row.houseName
      this.unitName = row.unitName
      this.roomName = row.roomName
      this.ownerName = row.ownerName
      this.roomDescribe = row.gardenName + ': ' + row.houseName + '号楼 ' + row.unitName + '单元 ' + row.roomName + '室'
      let loading = this.$loading()
      let params = {
        gardenId: this.gardenId,
        payerObjId: this.room,
        feeTypeCdName: this.feeTypeCdName,
        stateName: this.stateName,
        placeName: this.placeName,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        feeRoomOrCar: row.feeRoomOrCar,
        roomOwnerChildId : row.rId
       
      }
      this.$get(`/feePayInfo/`, params).then(
        (res) => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        (error) => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    commit() {
      this.pageNo = 1
      this.getTablelist(this.row)
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.getTablelist(this.row)
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.getTablelist(this.row)
    },
    handleRechargeCurrentChange(val) {
      this.rechargePageNo = val
      this.feeRechargeList(this.currentWeId)
    },
    handleRechargeSizeChange(val) {
      this.rechargePageNo = 1
      this.rechargePageSize = val
      this.feeRechargeList(this.currentWeId)
    },
    // 监听关闭dialog
    handleDialogClosed() {
      this.$refs.diaForm.resetFields()
      this.diaForm.unit = 0
      this.diaForm.house = 0
      this.diaForm.gardenId = ''
      this.diaForm.type = 1
      this.diaForm.name = ''
      this.diaForm.macName = ''
    },
    // 列表隔行变色
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    rechargeIndexMethod(index) {
      return (this.rechargePageNo - 1) * this.rechargePageSize + index + 1
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },

  },
}
</script>

<style lang="scss" >
.nextPMTime label {
  width: 150px !important;
}

.el-dialog .el-form .el-form-item {
  margin-right: 0;
  margin-bottom: 15px !important;
  // text-align: right;
}
.tagStyle {
  min-width: 100px;
  margin-top: 3px;
}
.el-tag.el-tag--info {
    background-color: #cdcdd0 !important;
    border-color: #fcf9f9 !important;
    color: #37383a !important;
}

.el-dialog__header {
    border-bottom: none !important;
}

.el-dialog .el-form {
    padding: 0px 10px 0 0px !important;
}

.el-divider--horizontal {
      margin: 15px 0 !important;
}
.aaa .cell{
  color: red;
}
// .el-divider--vertical {
//     height: 40em !important;
//     margin: 0 15px !important;
// }
.el-table th>.cell.highlight {
    color: red !important;
}
.ftc{
  color: red !important;
}
.revInput>.el-input__inner{
      height: 30px;
      padding: 0px 0px;
      width: 80%;
}
  .rechargeFrom{
    margin-left: 10px;
  }
   .haveParentIdstyle {
      color: #0f07fc;
      cursor: pointer;
    }
.place-name-filter-trigger {
  cursor: pointer;
  margin-left: 4px;
  color: #C0C4CC;
  vertical-align: middle;
}
.place-name-filter-trigger:hover,
.place-name-filter-trigger.is-active {
  color: #409EFF;
}
.place-name-filter-floating {
  width: 220px;
  padding: 12px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}
.place-name-filter-actions {
  margin-top: 10px;
  text-align: right;
}
</style>